var map = {
	"./de/general1/slide2.svg": 129949,
	"./en/general1/slide2.svg": 160649,
	"./es/general1/slide2.svg": 153108,
	"./fr/general1/slide2.svg": 284012,
	"./nl/general1/slide2.svg": 826090,
	"./pt/general1/slide2.svg": 263784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157269;